export default "/images/wifi-off.svg?0ffbf43a6f88e07f9cdd6d2f558c3395";